import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63e8fe62"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=63e8fe62&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e8fe62')) {
      api.createRecord('63e8fe62', component.options)
    } else {
      api.reload('63e8fe62', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=63e8fe62", function () {
      api.rerender('63e8fe62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/price/index.vue"
export default component.exports